import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsCatalogSections from "../generic-nav-bar/NavbarIconsCatalogSections";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { catalogSectionStartRegister } from "../../app/actions/catalogSectionActions";
import { schemaValidateCatalogSectionsList } from "../../app/data/schemaValidateCatalogSectionsList";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import ViewLabel from "../generic-component/ViewLabel";

const ID_FORM = "admin-section";
const OPERATION = "register";

const NewCatalogSections = () => {
  debugLogPages(':: NewCatalogSections');

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { catalogSection, listFullCatalogSectionsNoLevel6 } = useSelector((state) => state.catalogSection);

  const { t } = useTranslation();

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogSection,
     handleChangeCatalogPhase, handleChangeLocation, handleChangeCatalogSectionOne } = useFormValidationsGeneric(
      () => catalogSectionCallback(),
      catalogSection,
      schemaValidateCatalogSectionsList
    );

  useEffect(() => {

    if (values) {
      handleChange(getObjectById(values.parent_id, listFullCatalogSectionsNoLevel6), "parent_id");

    }

  }, [listFullCatalogSectionsNoLevel6])

  const getObjectById = (id, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.id === id);
    return elementFound;
  };

  const getMethodData = (currentData) => {
    let comboData = [];
    let level = 0;

    if (currentData === "parent_id") {
      comboData = listFullCatalogSectionsNoLevel6;
      level = 1;
    }

    return { comboData, level };
  };

  const catalogSectionCallback = () => {
    debugLogPages(':: NewCatalogSections, catalogSectionCallback, values', {values}); 

    let valuesSubmit = { ...values };

    valuesSubmit.deleted = false;

    debugLogPages(':: NewCatalogSections, catalogSectionCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(catalogSectionStartRegister(valuesSubmit, navigate));

  };

  debugLogPages(':: NewCatalogSections', {values}); 
  debugLogPages(':: NewCatalogSections', {errors}); 

  return (
    <div>
      <NavbarIconsCatalogSections page={"newCatalogSections"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateCatalogSectionsList && schemaValidateCatalogSectionsList.length > 0 && (
                  schemaValidateCatalogSectionsList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData, level } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}

                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      return (
                        <NewCatalogRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeCatalogSectionOne}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                          level={level}

                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric1") {
                      if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}

                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewCatalogSections;
